import { createValidator } from '@seek/validators-js';

import translations from 'src/utils/validators/userExistsOnAccount/.vocab';

export const { userExistsOnAccount } = createValidator({
  test: ({
    value,
    validatorProps: { users },
  }: {
    value: string;
    validatorProps: {
      users: Array<{ email: string }>;
      userExistsOnAccountMessage?: string;
    };
  }) => !users.some((user) => user.email.toLowerCase() === value.toLowerCase()),
  formatErrorMessages: (messages) => () => messages['User exists'].format(),
  translations,
  validatorName: 'userExistsOnAccount',
});
